import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const SmartInvoicingPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#0244021A',
            100: '#0244021A',
            200: '#024402',
            300: '#024402',
            400: '#024402',
            500: '#024402',
            600: '#023B02',
            700: '#023B02',
            800: '#023B02',
            900: '#013201',
            950: '#013201'
        }
    },
    components: {
        button: {
            colorScheme: {
                light: {
                    root: {
                        secondary: {
                            background: '#F9FDF7',
                            hoverBackground: '#F1FEEA',
                            activeBackground: '#E9F8DC',
                            borderColor: '#F9FDF7',
                            hoverBorderColor: '#F1FEEA',
                            activeBorderColor: '#E9F8DC',
                            color: '#668B7B',
                            hoverColor: '#4F7269',
                            activeColor: '#4F7269',
                            focusRing: {
                                color: '#668B7B',
                                shadow: 'none'
                            }
                        }
                    }
                }
            }
        }
    }
});
